import { createSelector } from '@ngrx/store';

import { basketModalsFeatureKey } from '../reducers/basket-modals.reducer';
import { selectBasketState } from '../store';

export const selectBasketModalsState = createSelector(
  selectBasketState,
  (state) => state[basketModalsFeatureKey],
);

export const selectDropShipModalState = createSelector(
  selectBasketModalsState,
  (state) => state.dropShip,
);

export const selectRequestReviewerModalState = createSelector(
  selectBasketModalsState,
  (state) => state.requestReviewer,
);

export const selectRejectReviewerModalState = createSelector(
  selectBasketModalsState,
  (state) => state.rejectReviewer,
);
